import MenuItem from './MenuItem';
import InsightsIcon from '@mui/icons-material/Insights';
import { ReactComponent as PlaylistIcon } from '../../icons/playlist.svg';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';
import { useContext } from 'react';
import { OrganisationContext } from '../../App';

export default function RightsholderViewOfPublisherMenu({ open }) {
  const { selectedOrganisationObject } = useContext(OrganisationContext);
  const orgtype = selectedOrganisationObject?.orgtype || [];

  return (
    <>
      <MenuItem open={open} path="/playlist" label="Playlists">
        <PlaylistIcon />
      </MenuItem>
      <MenuItem open={open} path="/video-library" label="Video Library">
        <PlaylistIcon />
      </MenuItem>
      { orgtype.includes('rightsholder') && <MenuItem open={open} path="/pixels-studio" label="Pixels Studio">
        <MovieFilterIcon />
      </MenuItem>}
      <MenuItem open={open} path="/gap-analysis" label="Gap Analysis">
        <InsightsIcon />
      </MenuItem>
    </>
  );
}

